// start:ng42.barrel
import './confirm-delete-preferences.component';
import './mass-assignment-methods-and-timetables.component';
import './mass-pupil-transport-assignment-main.component';
import './preference-updates-feedback.component';
import './pupil-preference-edit.component';
import './pupil-preference-selections.component';
// end:ng42.barrel

